import React from "react";
//Limitless imports
import { useExpertProfileContext } from "../../expert";
import { recordUserId } from "./AnalyticsHelper";
import { isAnalyticsEnabled } from "./AnalyticsPageViewRecorderHook";
export const useUsernameRecorder = () => {
  const {
    profile
  } = useExpertProfileContext();
  React.useEffect(() => {
    if (isAnalyticsEnabled && profile.userName) {
      recordUserId(profile.userName);
    }
  }, [profile.userName]);
};